var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 3H7.5C7.1023 3.0004 6.721 3.15856 6.43978 3.43978C6.15856 3.721 6.0004 4.1023 6 4.5V21C6.00046 21.3977 6.15864 21.7789 6.43984 22.0602C6.72105 22.3414 7.10232 22.4995 7.5 22.5H16.5C16.8977 22.4995 17.2789 22.3413 17.5601 22.0601C17.8413 21.7789 17.9995 21.3977 18 21V4.5C17.9995 4.10232 17.8414 3.72105 17.5602 3.43984C17.279 3.15864 16.8977 3.00046 16.5 3ZM16.5 4.5V6H7.5V4.5H16.5ZM7.5 21V7.5H16.5V21H7.5Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.23bc57c2460310cfb989a4706e4b60ba.svg";
export { ForwardRef as ReactComponent };